import { render } from "./SaleOrderDetailView.vue?vue&type=template&id=e22419f8&scoped=true"
import script from "./SaleOrderDetailView.vue?vue&type=script&lang=js"
export * from "./SaleOrderDetailView.vue?vue&type=script&lang=js"

import "./SaleOrderDetailView.vue?vue&type=style&index=0&id=e22419f8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22419f8"]])

export default __exports__